export default __webpack_public_path__ + "static/media/12.0202a18a.jpg";